<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 py-3">
        <div class="mb-4 flex">
            <BaseInputCheckbox
                v-model="formValues.no_answer"
                :required="isRequiredNaturalComplianceProfileAttribute('investment_goals', 'no_answer')"
                :label="$t('ecsp.investment_goals.no_answer')"
                name="investment_goals.no_answer" />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.sustainability"
                name="investment_goals.sustainability"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.SustainabilityAnswerOption,
                        'ecsp.sustainability'
                    )
                "
                :label="$t('ecsp.investment_goals.sustainability')"
                :required="isRequiredNaturalComplianceProfileAttribute('investment_goals', 'sustainability')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.investment_goal"
                name="investment_goals.investment_goal"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.InvestmentGoalAnswerOption,
                        'ecsp.investment_goal'
                    )
                "
                :label="$t('ecsp.investment_goals.investment_goal')"
                :required="isRequiredNaturalComplianceProfileAttribute('investment_goals', 'investment_goal')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.investment_horizon"
                name="investment_goals.investment_horizon"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.InvestmentHorizonAnswerOption,
                        'ecsp.investment_horizon'
                    )
                "
                :label="$t('ecsp.investment_goals.investment_horizon')"
                :required="isRequiredNaturalComplianceProfileAttribute('investment_goals', 'investment_horizon')"
                :disabled="disabled"
                vertical />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ecspPersonalComplianceProfileConfig } from '../../../account/personal/complianceProfile/ecspComplianceProfile'
import {
    clearFormValuesNoAnswer,
    getNaturalWidgetFormValidationRules,
    initializeNaturalWidgetForm,
    isRequiredNaturalComplianceProfileAttribute,
} from '../../ESAC/form/forms'
import { enumToSelectOptions } from '../../../../utilities/helpers'
import { computed, watch } from 'vue'
import { App } from '../../../../typings/api-enums'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import { useVModel } from '@vueuse/core'
import BaseInputRadio from '../../../base/BaseInputRadio.vue'

const props = defineProps<{
    modelValue: App.Services.ComplianceProfile.ECSP.Categories.Natural.EcspInvestmentGoalsDto
}>()
const emit = defineEmits(['update:modelValue'])
const formValues = useVModel(props, 'modelValue', emit)

const disabled = computed(() => {
    return formValues.value.no_answer === true
})

watch(
    () => formValues.value.no_answer,
    () => {
        clearFormValuesNoAnswer(formValues)
    }
)

initializeNaturalWidgetForm(
    getNaturalWidgetFormValidationRules(
        ecspPersonalComplianceProfileConfig['Investment Goals'].validationKey,
        'ecsp',
        ecspPersonalComplianceProfileConfig['Investment Goals'].denyKey
    ),
    null,
    'ecsp'
)
</script>
